interface HelpTexts {
  individuellaVal: { [key: string]: string };
  efterlevandeskydd: { [key: string]: string };
  basuppgifter: { [key: string]: string };
  arbetsgivare: { [key: string]: string };
  premier: { [key: string]: string };
}

const helpTexts: HelpTexts = {
  premier: {
    premier: `De vanligaste premier visas här. Collectums administrationsavgift visas t.ex. inte. Be kunden att logga in för en total översikt.<br><br>
              <strong>Datum</strong> Transaktionsdatum för premierna`,
    ordPremie: `ITP1 premie eller ITPK premie`,
    dpFlexPremie: `Extra inbetalningar till ITP1 eller ITPK som motsvarar en viss procent av lönen. Procentsatsen skiljer sig mellan de olika avtalen.`,
    lonevxPremie: `Den delen av lönen som är utbyt mot extra tjänstepension`,
    komplPremie: `Löpande extra inbetalningar till ITP1 eller ITP`,
    egPremie: `Engångs extra inbetalning till ITP1 eller ITPK`,
    frilPremie: `Pengar som betalas in till tiotaggarlösningen`,
    trappaPremie: `Pengar som betalas in till tiotaggarlösningen`,
    avstFpPremie: `Pengar som sätts in till ITPK istället för att ha familjepension (endast ITP2 med lön över 7,5 ibb)`,
    kostnFsPremie: `Summa som betalas för familjeskydd`,
    utlPremie: `Kompensation för att jobba i ett land utanför EU/EES och inte få inbetalningar till allmän pension i Sverige`,
  },
  arbetsgivare: {
    arbetsgivare: `Nuvarande och tidigare arbetsgivare med tjänstemän kollektivavtal inom den privata sektorn visas.<br><br>
                  Collectum har information om anställningar innan 2001.`,
  },
  basuppgifter: {
    anmaldArslon: `<strong>Anmäld årslön</strong> ITP2, månadslön x 12,2<br>
                  <strong>Datum</strong> Senaste datumet arbetsgivaren har rapporterat en lön till Collectum`,
    anmaldLon: `Anmäld lön = ITP1, kontant utbetald bruttolön per månad<br>
                Datum = senaste datumet arbetsgivaren har rapporterat en lön till Collectum`,
    pensionsmedforandeLon: `<strong>Pensionsmedförande lön (Justerad lön i Inloggad på avtalat.se)</strong> Lön efter lönekapning (ITP2)`,
    efterskyddslon: `<strong>Efterskyddslön</strong> Vid en lönesänkning gäller ett efterskydd på ”gamlagamla” lönen på 3 månader. Om man insjuknar inom 3 månader från lönesänkningen ska därför premiebefrielsebeloppet baseras på den gamla (högre) lönen som gällde innan lönesänkningen. Det är Alecta som beräknar efterskyddslönen och meddelar Collectum.`,
  },
  individuellaVal: {
    individuellaVal: `Här tydliggörs vilka (aktiva) val kunden har gjort för sitt efterlevandeskydd och vilka ändringar är pågående. Uppdateringen sker omgående.<br><br>
    <strong>Typ av efterlevandeskydd</strong> För återbetalningsskydd syns även pensionsplanen (ITP1, ITPK, ITPKPP, LP och UITPK) för valet <br><br>
    <strong>Gällande val</strong> Valet som gäller just nu. Uppdateras inom några minuter som kunden har gjort valet eller ändringen på avtalat.se.
    <ul>
      <li>Val utan text = återbetalningsskydd gäller retroaktiv för hela kapitalet</li>
      <li>Val med text "ej retroaktiv" = återbetalningsskydd gäller bara för kapital som är inbetald från och med "Giltig fr.o.m." datumet</li>
    </ul>
    <strong>Giltig från och med</strong> Anger datumet som valet gjordes.<br><br>
    <strong>Kommentar</strong> Följande 3 kommentarer kan finnas:
    <ol>
      <li>Hälsoprövning pågår</li>
      <li>Ändring pågår</li>
      <li>Avslag hälsoprövning</li>
    </ol>`,
  },
  efterlevandeskydd: {
    efterlevandeskydd: `Tjänstegrupplivförsäkring (TGL) visas inte. I Inloggad på avtalat.se under sektionen "För min familj" kan kunden se hur mycket ersättning deras efterlevande får från TGL.`,
    aterbetalningsskyddRapporterad: `<strong>Rapporterad</strong> Status som är återrapporterad från pensionsbolaget.<br>
                                     OBS! Detta kan skilja mellan statusen som finns under sektionen ”Individuella val” eftersom pensionsbolagen återrapporterar endast en gång i månaden.`,
    familjepension: `Information om avstående, fribrevsvärde och prognosbelopp.<br>
                     Om förmånstagaren är barn är utbetalningstiden endast till barnet fyller 20 år.`,
    familjeskydd: `Syns endast om kunden har valt det.<br>
                   Information om valt belopp och utbetalningstid.`,
  },
};

export default helpTexts;
